export const STRUCTURED_TEMPLATE_IDS = [
  'classic-editorial',
  'botanical-garden',
  'modern-black-tie',
  'destination-praia',
  'minimal-classic',
  'vintage-retro',
  'scandinavian-minimal',
  'por-do-sol',
  'noir-dorado',
  'terra-flores',
  'linha-pura',
  'jardim-secreto',
  'art-deco',
  'praia-brisa',
  'inverno-real',
  'veludo-rosa',
  'tipo-gigante',
  'sakura',
  'serra-nevoa',
  'parisiense',
  'tropical',
  'prata-eterno',
  'bohemia',
  'noite-estrelada',
  'azulejo-portugues'
];

export const EDITOR_TEMPLATE_IDS = [
  'classic-editorial',
  'botanical-garden',
  'modern-black-tie',
  'destination-praia',
  'minimal-classic',
  'vintage-retro'
];

export const isStructuredTemplateId = (templateId) => STRUCTURED_TEMPLATE_IDS.includes(templateId);
export const isEditorTemplateId = (templateId) => EDITOR_TEMPLATE_IDS.includes(templateId);
